<template>
  <v-content :class="['white', marging]">
    <div
      id="core-view"
      class="pa-5"
    >
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
  export default {
    name: 'CoreView',
    props: {
      marging: {
        type: String,
        default: "",
      },
    },

    metaInfo () {
      return {
        title: "Himydata"
      }
    }
  }
</script>